export default "__VITE_ASSET__7iO5J5Tv__"